export default class PhaserOverrides {
    static override(): void {
		// phaser's default display list can't handle items being added/removed from the list while it's being shut down,
		// this override fixes that
		Phaser.GameObjects.DisplayList.prototype.shutdown = function (this: Phaser.GameObjects.DisplayList): void {
			const list = this.list;
			while (list.length > 0) {
				const obj = list.pop();
				if (obj) obj.destroy();
			}
			list.length = 0;
			this.events.off(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
		};

		// phaser's default container adds objects to the scene when they're removed from their parent container.
		// this causes crashes when destroying a container during scene shutdown.
		const proto = <any>Phaser.GameObjects.Container.prototype;
		proto.removeHandler = function (this: Phaser.GameObjects.Container, gameObject: Phaser.GameObjects.GameObject): void {
			gameObject.off(Phaser.GameObjects.Events.DESTROY, this.remove);

			if (this.exclusive) {
				(<any>gameObject).parentContainer = null;

				// gameObject.addToDisplayList();
			}
		};

		// phaser's text objects listen for the CONTEXT_RESTORED event on construction,
		// but the event listener is never removed, causing a memory leak.
		const text = <any>Phaser.GameObjects.Text.prototype;
		const preDestroy = text.preDestroy;
		text.preDestroy = function (this: Phaser.GameObjects.Text, ...args: any[]): void {
			preDestroy.call(this, ...args);
			PhaserOverrides.removeEventsOf(this.scene.sys.game, this, Phaser.Core.Events.CONTEXT_RESTORED);
		};

		// ditto for BitmapMasks
		const bitmapMask = Phaser.Display.Masks.BitmapMask.prototype;
		const destroyMask = bitmapMask.destroy;
		bitmapMask.destroy = function (this: Phaser.Display.Masks.BitmapMask, ...args: any[]): void {
			this.renderer.game.events.removeListener(Phaser.Core.Events.CONTEXT_RESTORED, this.createMask, this);
			destroyMask.call(this, ...args);
		};

		// adding a tween and pausing it on the same frame puts it in a state where it can't be resumed
		// without calling play() and then resume() in that order. fixed by auto-calling play when calling
		// resume on a paused tween.
		const tween = Phaser.Tweens.Tween.prototype;
		tween.resume = function (): Phaser.Tweens.Tween {
			if (this.state === 21) {
				// TWEEN_CONST.PAUSED
				this.play();
				this.paused = false;
				this.state = this._pausedState;
			} else {
				this.play();
			}

			return this;
		};
	}

	static removeEventsOf(game: Phaser.Game, object: Phaser.GameObjects.GameObject, event: string): void {
		const events: { context: any; fn: () => void } | { context: any; fn: () => void }[] = (<any>game.events)._events[event];

		if ("filter" in events) {
			const listeners = events.filter((e) => e.context == object);
			for (const listener of listeners) {
				game.events.off(event, listener.fn);
			}
		} else {
			game.events.off(event, events.fn);
		}
	}
    
    //https://www.uriports.com/blog/easy-fix-for-intervention-ignored-attempt-to-cancel-a-touchmove-event-with-cancelable-false/
    //https://github.com/photonstorm/phaser/issues/3915
    static overrideTouchCancel(game: Phaser.Game):void {
        const _this = game.input.touch;
        if(_this==null) return;
        console.log("overrideTouchCancel");

        //Roll our own touch cancel that makes sure the event is cancelable before calling prevent default
        const touchCancel = (event:TouchEvent):void=>{
            console.log("touchcancel override");
            if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled)
            {
                (<any>_this.manager).onTouchCancel(event); //private hack
    
                if (_this.capture && event.cancelable)
                {
                    event.preventDefault();
                }
            }
        };

        //override start listeners to remove the internal listener & add our custom one
        const startListeners = game.input.touch.startListeners.bind(_this);
        game.input.touch.startListeners = ():void=>{
            startListeners.call(this);
            (<any>game.input.touch.target).removeEventListener('touchcancel', game.input.touch.onTouchCancel);
            (<any>game.input.touch.target).addEventListener('touchcancel', touchCancel, true);
        };
        //stop old listeners and restart with our new ones
        game.input.touch.stopListeners();
        game.input.touch.startListeners();
        
    }

}